module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag19_0921AT.28824da6.jpg";